import React from 'react';

// Asaas logo (top right) + who receives the payment
export const PayeeHeader = () => (
  <div data-testid="payee-header" style={{ marginBottom: '0.9rem' }}>
    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '0.5rem' }}>
      <img src="/asaas-logo.png" alt="Asaas" data-testid="asaas-logo" style={{ height: 28, width: 'auto' }} />
    </div>
    <div data-testid="payee-box" style={{ border: '1px solid #e2e8f0', background: '#f7fafc', borderRadius: 8, padding: '0.65rem 0.8rem', fontSize: '0.8rem', color: '#4a5568', lineHeight: 1.5 }}>
      <p style={{ marginBottom: 2 }}>Os pagamentos serão feitos em favor de:</p>
      <p data-testid="payee-name" style={{ fontWeight: 700, color: '#2D3748' }}>58.369.795 Cornelio Augusto Doro Pereira</p>
      <p>CNPJ: 58.369.795/0001-90</p>
      <p>Banco: 461 - Asaas I.P S.A</p>
      <p>Agência: 0001</p>
      <p>Conta: 8267138-9</p>
    </div>
  </div>
);
